import React from 'react'

const MovementsOfMeeting = () => {
  return (
    <div>
      
    </div>
  )
}

export default MovementsOfMeeting;
